import { ContractErrorMsgs as FormattedErrorMsgs } from './_types';

export enum EVestaErrorType {
  INTERNAL = 'INTERNAL_ERROR',
  EXTERNAL = 'EXTERNAL_ERROR',
  USER = 'USER_ERROR',
}

//VERBATIM CONTRACT ERROR CODES AND RESPONSE STRINGS
export enum ERROR_MSGS {
  ETHER_SESSION_NOT_INIT = 'Ether session not init.',
  ETHER_UNSUPPORTED_NET = 'Provider connected to an unsupported network.',

  CT_VAULT_LONELY_TROVE = 'execution reverted: TroveManager: Only one trove in the system',
  CT_VAULT_INVALID_DEBT = "execution reverted: BorrowerOps: Trove's net debt must be greater than minimum",
  CT_VAULT_INVALID_FUND_VST = 'execution reverted: BorrowerOps: Caller doesnt have enough VST to make repayment',
  CT_VAULT_INVALID_ICR_OVER_MRC = 'execution reverted: BorrowerOps: An operation that would result in ICR < MCR is not permitted',
  CT_VAULT_INVALID_ICR_OVER_CCR = 'execution reverted: BorrowerOps: Operation must leave vault with ICR >= CCR',
  CT_VAULT_INVALID_TCR_OVER_CCR = 'execution reverted: BorrowerOps: An operation that would result in TCR < CCR is not permitted',
  CT_VAULT_INVALID_NEW_IRC = "execution reverted: BorrowerOps: Cannot decrease your vault's ICR in Recovery Mode",
  CT_VAULT_ACTIVE = 'execution reverted: BorrowerOps: vault is active',
  CT_VAULT_LONE_TROVE = 'execution reverted: TroveManager: Only one vault in the system',
  CT_VAULT_404 = 'execution reverted: BorrowerOps: Vault does not exist or is closed',
  CT_PERMIT_EXPIRED = 'execution reverted: Permit: expired deadline',
  CT_PERMIT_INVALID_SIGNATURE = 'execution reverted: ERC20Permit: Invalid signature',
  CT_SYSTEM_RECOVERY_FAILED_ACTION = 'execution reverted: BorrowerOps: Operation not permitted during Recovery Mode',
  CT_SYSTEM_RECOVERY_FAILED_WITHDRAW = 'execution reverted: BorrowerOps: Collateral withdrawal not permitted Recovery Mode',
  CT_VAULT_INVALID_INPUT = 'execution reverted: BorrowerOp: Invalid Input. Override msg.value only if using ETH asset, otherwise use _tokenAmount',
  CT_VAULT_MINT_CAP_EXCEEDED = 'execution reverted: Reached the cap limit of vst.',

  CT_STABILITY_POOL_404 = 'execution reverted: Invalid asset StabilityPool',
  CT_SP_NON_ZERO_AMOUNT = 'execution reverted: StabilityPool: Amount must be non-zero',
  CT_STABILITY_POOL_NO_STAKE = 'execution reverted: StabilityPool: User must have a non-zero deposit',
  CT_INSUFFICIENT_BALANCE = 'insufficient balance for transfer',
  CT_INSUFFICIENT_BALANCE_2 = 'execution reverted: ERC20: transfer amount exceeds balance',
  CT_SP_NOT_ASSIGNED = "execution reverted: Stability pool hasn't been assigned",
  CT_NOT_APPROVED = 'execution reverted: ERC20: transfer amount exceeds allowance',
  CT_SP_WITHDRAW_ICR_ST_MCR = 'execution reverted: Cannot withdraw while there are troves with ICR < MCR',

  CT_FETCH_SYS_VAULT_FAIL = 'Failed to fetch vaults system data.',
  CT_FETCH_SYS_PARAMS_FAIL = 'Failed to fetch Vesta Parameters system data.',
  CT_FETCH_SYS_VAULTPOOL_FAIL = 'Failed to fetch Vesta Staking system data.',
  CT_FETCH_SYS_TOKEN_FAIL = 'Failed to fetch Token system data.',
  CT_FETCH_SYS_SP_FAIL = 'Failed to fetch Stability Pool system data.',
  CT_FETCH_SYS_PRICEFEED = 'Failed to fetch Price Feed system data. ',
  CT_FETCH_SYS_MULTI = 'Failed to fetch Multi vault Getter system data. ',
  CT_FETCH_SYS_LIQUIDITY_FAIL = 'Failed to fetch liquidity system data',

  CT_FETCH_USER_VAULT_FAIL = 'Vaults user data failed to fetch.',
  CT_FETCH_USER_VAULTPOOL_FAIL = 'VaultPool user data failed to fetch.',
  CT_FETCH_USER_TOKEN_FAIL = 'Token user data failed to fetch.',
  CT_FETCH_USER_SP_FAIL = 'Failed to fetch User Stability Pool system data.',
  CT_FETCH_USER_WHITELIST_CLAIMED = 'Failed to fetch whitelist claim status.',
  CT_FETCH_USER_LIQUIDITY_FAIL = 'Failed to fetch liquidity user data.',
  CT_VSTA_STAKING_NO_STAKE = 'execution reverted: VSTAStaking: User must have a non-zero stake',
  CT_FETCH_FRAX_STAKING_FAIL = 'Failed to fetch frax staking data',

  CT_REDEEM_VST_AMOUNT_TOO_SMALL = 'execution reverted: TroveManager: Amount must be greater than zero',
  CT_REDEEM_VST_ORACLE_OUTDATED = 'execution reverted: TroveManager: Unable to redeem any amount',

  PROVIDER_NO_REQUEST_FUNC = 'Injected window provider is not valid or does not have an implementation!',
  PROVIDER_NOT_CONNECTED = 'Provider not connected!',
  PROVIDER_MISSING = 'Injected provider not found!',
  PROVIDER_MULTI_INVALID = 'Multicall provider is invalid!',
  PROVIDER_REGISTER_EVENT_FAILED = 'Couldnt register event',
  PROVIDER_WALLET_CONNECT_CANCEL = 'User closed modal',
  PROVIDER_REQUESTING_ACCOUNT = 'Already processing eth_requestAccounts. Please wait.',

  MM_TX_USER_DENY = 'MetaMask Tx Signature: User denied transaction signature.',

  REACT_QUERY_CANNOT_FETCH = 'Cannot fetch data',

  CT_UNDEFINED_ERROR = 'execution reverted',

  ETHERS_4001 = 4001,
  ETHERS_4100 = 4100,
  ETHERS_4901 = 4901,
  ETHERS_4902 = 4902,
  ETHERS_32603 = -32603,
  INVALID_ERROR = -404,
}

//USER FRIENDLY REPLACEMENT ERROR MESSAGES
export const CONTRACT_DISPLAY_ERRORS: FormattedErrorMsgs = {
  [ERROR_MSGS.CT_VAULT_LONELY_TROVE]: 'You may not close vault, if you are the only vault open!',
  [ERROR_MSGS.ETHER_SESSION_NOT_INIT]:
    'No injected provider! Please install a crypto wallet in order to use the dApp.',
  [ERROR_MSGS.ETHER_UNSUPPORTED_NET]: 'Please connect to a supported network!',

  [ERROR_MSGS.CT_PERMIT_EXPIRED]: 'Permit expired.',
  [ERROR_MSGS.CT_PERMIT_INVALID_SIGNATURE]: 'User signature is invalid! Please try the transaction again.',
  [ERROR_MSGS.CT_SYSTEM_RECOVERY_FAILED_ACTION]:
    'Operation is not permitted while the system is in recovery mode.',
  [ERROR_MSGS.CT_SYSTEM_RECOVERY_FAILED_WITHDRAW]:
    'Collateral withdrawal not permitted while system is in Recovery Mode',
  [ERROR_MSGS.CT_STABILITY_POOL_404]: 'Stability pool does not exist!',
  [ERROR_MSGS.CT_VAULT_404]:
    'Your vault has been previously closed or liquidated. This vault does not exist! ',
  [ERROR_MSGS.CT_VAULT_INVALID_NEW_IRC]:
    "Operations cannot decrease your Vault's collateral ratio, while system is in recovery mode.",
  [ERROR_MSGS.CT_VAULT_ACTIVE]: 'Vault is already active!',
  [ERROR_MSGS.CT_VAULT_INVALID_ICR_OVER_MRC]:
    'Your collateral to debt ratio must be bigger that the minimum collateral ratio!',
  [ERROR_MSGS.CT_VAULT_INVALID_ICR_OVER_CCR]: 'Operation must leave vault with ICR >= CCR',
  [ERROR_MSGS.CT_VAULT_INVALID_TCR_OVER_CCR]: 'An operation that would result in TCR < CCR is not permitted',
  [ERROR_MSGS.CT_VAULT_INVALID_DEBT]: `Your net debt must be greater than the minimum debt`,
  [ERROR_MSGS.CT_VAULT_INVALID_FUND_VST]: 'You do not have enough VST to pay current vault debt.',
  [ERROR_MSGS.CT_VAULT_INVALID_INPUT]: 'Collateral amount must be bigger than 0.',
  [ERROR_MSGS.CT_VAULT_LONE_TROVE]: 'You cannot close vault if you are the only open vault in the system!',
  [ERROR_MSGS.CT_NOT_APPROVED]: 'User must approve spending before operation!',
  [ERROR_MSGS.CT_VSTA_STAKING_NO_STAKE]: 'You must have a stake to perform this operation!',
  [ERROR_MSGS.CT_VAULT_MINT_CAP_EXCEEDED]: 'Your borrow amount cannot make a vault exceed its VST mint cap!',

  [ERROR_MSGS.CT_FETCH_SYS_VAULT_FAIL]:
    'Failed to fetch Vaults system data. Please refresh page, or contact an administrator!',
  [ERROR_MSGS.CT_FETCH_SYS_VAULTPOOL_FAIL]:
    'Failed to fetch VaultPool system data. Please refresh page, or contact an administrator!',
  [ERROR_MSGS.CT_FETCH_SYS_TOKEN_FAIL]:
    'Failed to fetch Token system data. Please refresh page, or contact an administrator!',
  [ERROR_MSGS.CT_FETCH_SYS_SP_FAIL]:
    'Failed to fetch Stability Pool system data. Please refresh page, or contact an administrator!',
  [ERROR_MSGS.CT_FETCH_SYS_PRICEFEED]:
    'Failed to fetch Price Feed system data. Please refresh page, or contact an administrator!',
  [ERROR_MSGS.CT_FETCH_SYS_MULTI]:
    'Failed to fetch Multi Vault Getter system data. Please refresh page, or contact an administrator!',
  [ERROR_MSGS.CT_FETCH_SYS_PARAMS_FAIL]:
    'Failed to fetch system parameters. Please refresh page, or contact an administrator!',
  [ERROR_MSGS.CT_FETCH_USER_VAULT_FAIL]:
    'Failed to fetch Vaults user data. Please refresh page, or contact an administrator!',
  [ERROR_MSGS.CT_FETCH_USER_VAULTPOOL_FAIL]:
    'Failed to fetch Vault Pool user data. Please refresh page, or contact an administrator!',
  [ERROR_MSGS.CT_FETCH_USER_TOKEN_FAIL]:
    'Failed to fetch Token user data. Please refresh page, or contact an administrator!',
  [ERROR_MSGS.CT_FETCH_USER_SP_FAIL]:
    'Failed to fetch Stability Pool system data. Please refresh page, or contact an administrator!',
  [ERROR_MSGS.CT_FETCH_USER_WHITELIST_CLAIMED]:
    'Failed to fetch Whitelist user data. Please refresh page, or contact an administrator!',
  [ERROR_MSGS.CT_FETCH_USER_LIQUIDITY_FAIL]:
    'Failed to fetch Liquidity user data. Please refresh page, or contact an administrator!',
  [ERROR_MSGS.CT_FETCH_FRAX_STAKING_FAIL]:
    'Failed to fetch Frax user data. Please refresh page, or contact an administrator!',
  [ERROR_MSGS.CT_FETCH_SYS_LIQUIDITY_FAIL]:
    'Failed to fetch Liquidity system data. Please refresh page, or contact an administrator!',

  [ERROR_MSGS.CT_SP_NON_ZERO_AMOUNT]: 'Stability Pool stake amount must be non-zero.',
  [ERROR_MSGS.CT_STABILITY_POOL_NO_STAKE]: 'Cannot claim without a stake. There is nothing to claim!',
  [ERROR_MSGS.CT_INSUFFICIENT_BALANCE]: 'Insufficient balance to complete transaction.',
  [ERROR_MSGS.CT_INSUFFICIENT_BALANCE_2]: 'Insufficient balance to complete transaction.',
  [ERROR_MSGS.CT_SP_WITHDRAW_ICR_ST_MCR]: 'Cannot withdraw while there are troves with ICR < MCR.',

  [ERROR_MSGS.CT_REDEEM_VST_AMOUNT_TOO_SMALL]: 'Amount of vst is too small to redeem!',
  [ERROR_MSGS.CT_REDEEM_VST_ORACLE_OUTDATED]:
    'Redemption has failed, please try again or increase your gas limit.',

  [ERROR_MSGS.PROVIDER_NO_REQUEST_FUNC]: 'Internal provider error.',
  [ERROR_MSGS.PROVIDER_NOT_CONNECTED]: 'Provider is not connect.',
  [ERROR_MSGS.PROVIDER_MISSING]: '',
  [ERROR_MSGS.PROVIDER_MULTI_INVALID]: 'Multicall provider is invalid!',
  [ERROR_MSGS.PROVIDER_REGISTER_EVENT_FAILED]: 'Could not register provider event!',
  [ERROR_MSGS.PROVIDER_WALLET_CONNECT_CANCEL]: 'Connection cancelled by user!',
  [ERROR_MSGS.CT_SP_NOT_ASSIGNED]: 'Stability pool not assigned.',

  [ERROR_MSGS.CT_UNDEFINED_ERROR]: 'Undefined contract error.',

  [ERROR_MSGS.ETHERS_4001]: 'Request rejected.',
  [ERROR_MSGS.ETHERS_4100]: 'Request unauthorized.',
  [ERROR_MSGS.ETHERS_4901]: 'Wallet not connected to the active chain!',
  [ERROR_MSGS.ETHERS_4902]: 'dev plz',
  [ERROR_MSGS.ETHERS_32603]: 'Interaction reverted. Encountered an undefined error.',
  [ERROR_MSGS.PROVIDER_REQUESTING_ACCOUNT]: 'A request is already processing.',
  [ERROR_MSGS.INVALID_ERROR]: 'Invalid error response.',
  [ERROR_MSGS.MM_TX_USER_DENY]: 'Request rejected.',

  [ERROR_MSGS.REACT_QUERY_CANNOT_FETCH]:
    'Cannot perform query. Network is invalid or address/es are missing.',
};

export class VestaError extends Error {
  extra?: any;
  type: EVestaErrorType;

  constructor(msg: string, type: EVestaErrorType = EVestaErrorType.USER, extra?: string) {
    super(`${msg} ${extra ? `${extra}. ` : ''}`);
    this.type = type;
    this.extra = extra;
  }
}
